import {z as zod} from "zod";

export type AnalyticalEngineWorkspaceCapabilityConfiguration = Record<string, never>;

export const analyticalEngineWorkspaceCapabilityConfigurationValidator: zod.ZodType<AnalyticalEngineWorkspaceCapabilityConfiguration> = zod.strictObject({});
